import { useAuth } from '@clerk/clerk-react';
import useSWR from 'swr';
import { spacesApi } from '@/lib/api';
import { ownRuleChips } from '@/lib/spaces/rules';
import type { MySpaceRulesOverview } from '@/types/spaces';
import { LONG_LIVED_SWR_OPTIONS, useAuthedFetcher } from './swrConfig';

// The signed-in person's own sending rules for ONE space, for the space home (ruled 2026-09-20). Read-only, and
// deliberately apart from `useSpaceRulesOverview`: that hook carries the pause/resume writes of the personal
// rules page and stays inactive inside a space. Both share one cache key, so a rule paused on the rules page is
// already up to date here. The chips are an extra on the card: a failed or malformed read shows none.
export function useSpaceOwnRules(spaceId: string): string[] {
  const { userId } = useAuth();
  const fetch = useAuthedFetcher();
  const query = useSWR<MySpaceRulesOverview, Error>(userId ? ['space-rules-overview', userId] : null,
    () => fetch(spacesApi.rulesOverview), { ...LONG_LIVED_SWR_OPTIONS, keepPreviousData: false, shouldRetryOnError: false });
  return query.error ? [] : ownRuleChips(query.data, spaceId);
}
